var React = require('react');

function MenuOpenInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1 1L13.7279 13.7279","stroke":"#212355","strokeWidth":"2","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M1 13.728L13.7279 1.00011","stroke":"#212355","strokeWidth":"2","strokeLinejoin":"round","key":1})]);
}

MenuOpenInline.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none"};

module.exports = MenuOpenInline;

MenuOpenInline.default = MenuOpenInline;
